import { Star } from "lucide-react";
import { pick } from "src/utils/localize";

// Блок расширенного описания тура — карточка.
// Если в админке у блока стоит галочка «Выделить», он получает золотую
// рамку, подсветку и звезду: так важный пункт видно сразу.
export const Description = ({ feature, selectedLanguage }) => {
  const highlighted = Boolean(feature?.highlight);

  return (
    <div
      className={`rounded-2xl border p-5 sm:p-6 transition-colors ${
        highlighted
          ? "border-kj-gold/60 bg-kj-gold/[0.07] shadow-[0_0_0_1px_rgba(0,0,0,0)_,0_8px_30px_-12px_rgba(0,0,0,0.5)]"
          : "border-kj-line bg-kj-card/50"
      }`}
    >
      <dt className="flex items-start gap-2.5">
        {highlighted && (
          <Star
            className="mt-1 h-4 w-4 flex-shrink-0 fill-kj-gold text-kj-gold"
            aria-hidden="true"
          />
        )}
        <span
          className={`text-lg font-bold ${
            highlighted ? "text-kj-gold" : "text-kj-ink"
          }`}
        >
          {pick(feature?.name, selectedLanguage)}
        </span>
      </dt>
      <dd
        className={`mt-3 text-base leading-relaxed ${
          highlighted ? "text-neutral-200" : "text-kj-sub"
        }`}
      >
        {pick(feature?.description, selectedLanguage)}
      </dd>
    </div>
  );
};
